<template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      <v-flex v-if="!Update_Details">Add</v-flex>
      <v-flex v-else>Update</v-flex>
    </v-card-title>
    <v-card-text>
      <v-flex>
        <v-select v-model="SelectedCategory" :items="CategoryList" label="Select Category"></v-select>
      </v-flex>
      <v-flex>
        <v-text-field label="Course Category Name" v-model="Course_Category_Name"></v-text-field>
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" v-if="!Update_Details" @click="AddCourseCategory">Add Course Category</v-btn>
      <v-btn color="primary" v-else @click="UpdateCourseCategory">Update Course Category</v-btn>
      <v-btn color="primary" flat @click="ClearForm">Clear</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: ["dialog"],
  data() {
    return {
      Update_Details: false,
      Course_Category_Id: "",
      Course_Category_Name: "",
      SelectedCategory: ""
    };
  },
  computed: {
    CategoryList() {
      return this.$store.getters.GetCategoryList.map(x => x["Category_Name"]);
    }
  },
  methods: {
    ClearForm() {
      this.Update_Details = false;
      this.Course_Category_Name = "";
      this.SelectedCategory = "";
    },
    OpenToUpdate(Item) {
      this.Update_Details = true;
      this.Course_Category_Name = Item["Course_Category_Name"];
      this.Course_Category_Id = Item["_id"];
      this.SelectedCategory = this.$store.getters.GetCategoryList.find(
        x => x["_id"] == Item["Category_Id"]
      )["Category_Name"];
    },
    AddCourseCategory() {
      let data = {};
      data["Course_Category_Name"] = this.Course_Category_Name;
      data["Course_Category_URL"] = this.Course_Category_Name.toLowerCase().split(" ").join("-");
      data["Category_Id"] = this.$store.getters.GetCategoryList.find(x => x["Category_Name"] == this.SelectedCategory)["_id"];

      let Duplicate = this.$store.getters.GetCourseList.find(x => x['Course_Category_URL'] == data["Course_Category_URL"])
      if (this.Course_Category_Name && this.SelectedCategory && !Duplicate) {
        
        this.$http.post(`${this.$store.getters.GetProductionUrl}/course/addcourse`,data )
          .then(response => {

            this.$store.commit("SetIndividualCourse",response["data"]["response"]);
            this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Successfully Added Course Category", Color: "green", Close: false });
            this.ClearForm();
          })
          .catch(err => {

            this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error While Adding Course Category", Color: "red", Close: false });
          });
      } else {

        this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Check the Course Category Name", Color: "red", Close: false });
      }
    },
    UpdateCourseCategory() {
      let data = {};
      data["id"] = this.Course_Category_Id;
      data["update"] = {};
      data["update"]["Course_Category_Name"] = this.Course_Category_Name;
      data["update"][
        "Course_Category_URL"
      ] = this.Course_Category_Name.toLowerCase()
        .split(" ")
        .join("-");
      data["update"]["Category_Id"] = this.$store.getters.GetCategoryList.find(
        x => x["Category_Name"] == this.SelectedCategory
      )["_id"];

      if (
        this.Course_Category_Id &&
        this.Course_Category_Name &&
        this.SelectedCategory
      ) {
        
        this.$http
          .post(
            `${this.$store.getters.GetProductionUrl}/course/updatecourse`,
            data
          )
          .then(response => {
            this.$store.commit(
              "UpdateIndividualCourse",
              response["data"]["response"]
            );
            this.$eventHub.$emit("SNACK_BAR", {
              Show: true,
              Text: "Successfully Updated Course Category",
              Color: "green",
              Close: false
            });
            this.ClearForm();
          })
          .catch(err => {
            this.$eventHub.$emit("SNACK_BAR", {
              Show: true,
              Text: "Error While Updating Category",
              Color: "red",
              Close: false
            });
          });
      } else {
        this.$eventHub.$emit("SNACK_BAR", {
          Show: true,
          Text: "Failed To Update Course",
          Color: "red",
          Close: false
        });
      }
    }
  }
};
</script>
<style scoped>
</style>
